// 3rd
import { Model } from '@vuex-orm/core';
import {
    LOADER_CHECKOUT,
    LOADER_ADD_CART,
    LOADER_UPDATE_CART,
    LOADER_REMOVE_CART,
    API_ENDPOINT_ADD_TO_CART,
    LOADER_CART,
    API_ENDPOINT_FETCH_CART,
    API_ENDPOINT_REMOVE_FROM_CART,
    API_ENDPOINT_UPDATE_ON_CART,
    API_ENDPOINT_CHECKOUT_CART,
    API_ENDPOINT_LOGIN,
} from '../utils/constants';
import {
    api,
    authHeaders,
    errorHandler
} from '../utils/api';
import Product from './Product';

export default class Cart extends Model {
    static entity = 'carts';

    static fields() {
        return {
            id: this.attr(null),
            product_id: this.attr(null),
            quantity: this.attr(null),
            product: this.belongsTo(Product, 'product_id'),
        }
    }

    // api calls
    static async fetch() {
        Cart.store().dispatch('wait/start', LOADER_CART);

        const response = await api.get(API_ENDPOINT_FETCH_CART, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data: { cart } } = response;
        Cart.insert({
            data: cart,
        });

        Cart.store().dispatch('wait/end', LOADER_CART);
    }

    static async add(item) {
        Cart.store().dispatch('wait/start', LOADER_ADD_CART);

        const response = await api.post(API_ENDPOINT_ADD_TO_CART, item, authHeaders()).catch(errorHandler);
        const { data } = response;
        const product = {
            id: data.item.id,
            product_id: data.item.product_id,
            quantity: `${data.item.current_quantity}`,
        };

        Cart.insert({
            data: product,
        });

        Cart.store().dispatch('wait/end', LOADER_ADD_CART);
    }

    static async change(cartId, quantity) {
        Cart.store().dispatch('wait/start', LOADER_UPDATE_CART);

        const response = await api.post(API_ENDPOINT_UPDATE_ON_CART, { product_id: Number(cartId), quantity }, authHeaders()).catch(errorHandler);
        const { data: { item } } = response;

        Cart.update({
            where: item.id,
            data: {
               quantity: `${quantity}`,
            },
        });

        Cart.store().dispatch('wait/end', LOADER_UPDATE_CART);
    }

    static async remove(productId) {
        Cart.store().dispatch('wait/start', LOADER_REMOVE_CART);

        await api.post(API_ENDPOINT_REMOVE_FROM_CART, { product_id: Number(productId) }, authHeaders()).catch(errorHandler);

        Cart.delete((entry) => {
            return entry.product_id === Number(productId);
        });

        Cart.store().dispatch('wait/end', LOADER_REMOVE_CART);
    }

    static async checkout(address, email) {
        Cart.store().dispatch('wait/start', LOADER_CHECKOUT);

        return await api.post(API_ENDPOINT_CHECKOUT_CART, { address: address, email: email }, authHeaders());
    }

    // getters
    static getAll() {
        return Cart.query().withAll().all();
    }

    static isContainingInvalidProduct() {
        let isContainingInvalidProduct = false;
        Cart.query().withAll().all().forEach((item) => {
            if (!item.product.active || item.product.unavailable || !item.product.available_in_country) {
                isContainingInvalidProduct = true;
            }
        });
        return isContainingInvalidProduct;
    }

    static isBulky() {
        let isContainingBulky = false;
        Cart.query().withAll().all().forEach((item) => {
            if (item.product.measurement_cargo) {
                isContainingBulky = true;
            }
        });
        return isContainingBulky;
    }

    static isContainingDigitalProducts() {
        let isContainingDigitalProducts = false;
        Cart.query().withAll().all().forEach((item) => {
            if (item.product.type === 'digital') {
                isContainingDigitalProducts = true;
            }
        });
        return isContainingDigitalProducts;
    }

    static isContainingPhysicalProducts() {
        let isContainingPhysicalProducts = false;
        Cart.query().withAll().all().forEach((item) => {
            if (item.product.type === 'physical') {
                isContainingPhysicalProducts = true;
            }
        });
        return isContainingPhysicalProducts;
    }

    static getTotal() {
        return this.getAll().reduce((accumulator, currentValue) => {
            return currentValue.product.active ? accumulator + (currentValue.quantity * currentValue.product.price) : accumulator;
        }, 0);
    }

    static getSize() {
        return this.getAll().reduce((accumulator, currentValue) => {
            return currentValue.product.active ? accumulator + Number(currentValue.quantity) : accumulator;
        }, 0);
    }
}
